import { createTransform } from 'redux-persist'
import storage from 'redux-persist/es/storage'

const usersSerialize = state => ({
  authorization: state.authorization,
  sign_up: { referral_code: state.sign_up.referral_code }
})
const usersDeserialize = state => state

const usersTransform = createTransform(
  (inboundState, key) => usersSerialize(inboundState, key),
  (outboundState, key) => usersDeserialize(outboundState, key),
  { whitelist: ['users'] }
)

const localeSerialize = state => ({ locale: state.locale })
const localeDeserialize = state => state

const localeTransform = createTransform(
  (inboundState, key) => localeSerialize(inboundState, key),
  (outboundState, key) => localeDeserialize(outboundState, key),
  { whitelist: ['i18n'] }
)

const paymentsSerialize = state => ({ stripe: { index: { payment: state.stripe.index.payment } } })
const paymentsDeserialize = state => state

const paymentsTransform = createTransform(
  (inboundState, key) => paymentsSerialize(inboundState, key),
  (outboundState, key) => paymentsDeserialize(outboundState, key),
  { whitelist: ['payments'] }
)

const transforms = [usersTransform, localeTransform, paymentsTransform]

export default {
  key: 'ibbp',
  storage,
  keyPrefix: 'v0.0.1:',
  transforms,
  whitelist: ['users', 'i18n', 'payments']
}



// WEBPACK FOOTER //
// ./src/persist.js